import {Injectable} from '@angular/core';
import MessagingThread from '../../model/messagingThread.model';
import {HttpClient} from '@angular/common/http';
import GenericCrudService from "../genericCrud.service";
import {environment} from "../../environments/environment";
import Pagination from "../../model/pagination";
import {Observable} from "rxjs";
import QueryEncoder from "../queryEncoder";

@Injectable()
export default class MessagingThreadService extends GenericCrudService<MessagingThread> {
    constructor(http: HttpClient) {
        super(http);
    }

    getApiName() {
        return 'messaging/threads'
    }

    public followUps(query?: string, page?: number, limit?: number, additionalInfo?: any): Observable<Pagination<MessagingThread>> {
        query = query || '';
        page = page || 1;
        limit = limit || 15;


        let q = {query, page, limit};

        if(additionalInfo) {
            Object.assign(q, additionalInfo);
        }

        return this.http.get<Pagination<MessagingThread>>(environment.apiUrl + '/messaging/threads/follow-up' + '?' + QueryEncoder.encodeURI(q));
    }

    public unanswered(query?: string, page?: number, limit?: number, additionalInfo?: any): Observable<Pagination<MessagingThread>> {
        query = query || '';
        page = page || 1;
        limit = limit || 15;


        let q = {query, page, limit};

        if(additionalInfo) {
            Object.assign(q, additionalInfo);
        }

        return this.http.get<Pagination<MessagingThread>>(environment.apiUrl + '/messaging/threads/unanswered' + '?' + QueryEncoder.encodeURI(q));
    }

    public new(query?: string, page?: number, limit?: number, additionalInfo?: any): Observable<Pagination<MessagingThread>> {
        query = query || '';
        page = page || 1;
        limit = limit || 15;


        let q = {query, page, limit};

        if(additionalInfo) {
            Object.assign(q, additionalInfo);
        }

        return this.http.get<Pagination<MessagingThread>>(environment.apiUrl + '/messaging/threads/new' + '?' + QueryEncoder.encodeURI(q));
    }
}
